import React from 'react'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import Services from '../components/Services'

const Service = () => {
    return (
        <>
            <Navbar />
           
            
            <Services />
            
            <Footer />
        </>
    )
}

export default Service
